import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { LawyerLevel } from '../../models/lawyers/lawyerLevel';

@Component({
  selector: 'app-positions-create-edit',
  templateUrl: './positions-create-edit.component.html',
  styleUrls: ['./positions-create-edit.component.scss']
})
export class PositionsCreateEditComponent implements OnInit {

  public position: LawyerLevel;

  @ViewChild('positionsModal') positionsModal;
  @Output() submit: EventEmitter<LawyerLevel> = new EventEmitter<LawyerLevel>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: LawyersApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(position: LawyerLevel) {
    this.position = Object.assign(new LawyerLevel(), position);
    this.modalRef = this.modalService.open(this.positionsModal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  close() {
    this.closeModal.emit();
    this.modalRef.close();
  }

  onSubmit(f) {
    if (this.position.id) {
      this.spinner.show();
      this.api.updateLawyerLevel(this.position).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    } else {
      this.spinner.show();
      this.api.createLawyerLevel(this.position).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    }
  }

}
